import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow';
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query Inspections {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

const escape = '"< 2/32in"'

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: 'Inspections',
    subtitle: `There is more to inspections than meets the eye glass. The practice of examining your workplace or tools, comparing what is observed to a predetermined checklist, and recording on a form that the inspection took place are all great steps towards making your workplace safer, but the real value is in what takes place after the inspection.`,
    featureName: 'inspections',
    rightButtonText: 'Why Certificate Tracking Software?',
    rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
    mockupImg: '/features/inspections/feature-page-header-inspections.png'
  }

  const seo = {
    title: 'Workhub | Free Inspections Software Hazards Equipment Machinery',
    description: 'Our Inspections Software makes it easy to identify risk, monitor workplace safety & inspect equipment, machinery & tools so you can reduce hazards and boost productivity.',
    image: '/features/inspections/social-card.jpg',
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Customized Checklists",
      para: "Create your checklist of items to inspect and add guidance to help workers complete them all online.",
    },
    {
      title: "Scheduled Intervals",
      para: "Assign a frequency in which inspections of assets or sites must occur. ",
    },
    {
      title: "View Trends",
      para: "See detailed history for each check and track its changes over time or look up the inspection history for an asset or site. ",
    },
    {
      title: "Follow up Actions",
      para: "Approve, comment, or create action items from submitted inspections to track that concerns are being dealt with appropriately.",
    },
    {
      title: "Approval",
      para: "Inspections requiring a review will appear as outstanding in the Administrator dashboard.",
    },

  ]


  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">





        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  {/* <img
            className="feature-img-right push-down"
            src="\features\inspections\inspections-computer.png"
            alt="Inspections Admin View"
          /> */}

                  <img
                    className="feature-img-right push-down"
                    src="/features/inspections/inspections-cartoon.png"
                    alt="Inspections Admin View"
                  />
                </ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">

                <h3>Build an inspection checklist</h3>
                <p>A well-executed inspection requires a checklist of hazards to identify and controls that must be in place to ensure a worksite can be occupied or a piece of equipment is in good working order.</p>
                <p>Because every worksite or piece of equipment could be different, your checklists should be too. Inspections allow you to tailor each and every check so you can build a perfectly customized list for your workers to use. You can also specify if workers should include comments, photos, or actionable items with every check they complete.</p>




              </div>
            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row">


              <div className="col-lg-6 feature-text">

                <h3 style={{ marginTop: '1rem' }}>Customized check statuses</h3>
                <p>While statuses such as “Pass”, “Warning”, or “Issue” might encompass your needs, the statuses your Workers can select are customizable by you as an admin. For instance, you might want to change the “Pass” status to “Good”, or the “Issue” status to “Fail.”  Whatever you choose, you can provide guidance tips for your inspectors to successfully complete the inspection, such as “Tire tread must be less than 2/32in.”</p>
                <p>There are four possible statuses you can enable for each check, and you can disable two of them should you want to limit the choices for your inspectors for certain circumstances.</p>

                <strong style={{ fontSize: '18px' }}>Still More Inspection Status Settings</strong>
                <p style={{marginBottom: '0px'}}>Now comes the fun part - choosing what happens to each check under the various inspection statuses.</p>

                <ul className="checklist">
                  <li>
                    Comments are always required on Warning and Issue statuses, but you can also require them for Pass or N/A statuses
                  </li>
                  <li>
                    Photos are always optional for any check, but you can make them required for certain statuses (Issue comes to mind!)
                  </li>
                  <li>
                    Admin review and approval is mandatory on Issue statuses, but you can choose to include Warning statuses need the same treatment
                  </li>
                  <li>
                    Critical Issue notifications will be sent to your chosen recipients if the Issue status is indicated by an inspector, and you can choose to have the same notification sent for select other Warning statuses as well
                  </li>                
                </ul>
              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInRight" delay="0.9s">

                  <img
                    className="feature-img-left push-down"
                    src="/features/inspections/inspections-tablet.png"
                    alt="Inspections Tablet View"
                  />

                </ReactWOW>

              </div>

            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right push-down"
                    src="/features/inspections/inspections-computer.png"
                    alt="Inspections Admin View"
                  />

                </ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">

                <h3>Inspection assignments and frequency</h3>
                <p>Because inspections are conducted at locations or on equipment, that’s how they’re assigned in Workhub. You can assign the same inspection to multiple locations or pieces of equipment, depending on the fit. After the inspection is assigned, you also get to decide how often it needs to be completed, with options as often as every day or as seldom as every five years. Notifications will appear for workers for those inspections that need completion. Schedules are complicated and our inspections respect and respond to that.</p>
                <p>Inspections can easily be completed on any phone, tablet, or computer. The inspector simply chooses which location or piece of equipment the inspection is for, then completes each of the checks in the list. Depending on what’s being inspected, inspectors may need to enter an odometer or hour reading.</p>
                <p>As the inspector completes each check, they may be prompted to add a comment, upload a photo, or create an actionable deficiency to be followed up on. Once all the checks are filled, the inspector can submit the inspection for admin review.</p>
              </div>
            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row">


              <div className="col-lg-6 feature-text">

                <h3>Administrator review and approval</h3>
                <p>Inspections submitted by workers will be stored in Workhub for review. Those requiring admin action will appearing as outstanding for administrators, and adding a comment, photo, or action item will allow those submissions to be signed off as reviewed. After submission, all inspections can be downloaded as PDFs, as can photo supplements PDFs and full-sized image zip folders. </p>
              </div>

              <div className="col-lg-6 feature-img">
                <ReactWOW animation="fadeInRight" delay="0.9s">

                  <img
                    className="feature-img-left push-down"
                    src="/features/inspections/inspections-tablet-two.png"
                    alt="Inspections Tablet View"
                  />

                </ReactWOW>
              </div>

            </div>
          </div>
        </section>









        {/* FEATURE OVERVIEW */}

        <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>

      </main>


    </Layout>
  )
}